"use client";
import SvgVwSymbol from "./vw_symbol.svg.js";
import SvgVwWordmark from "./vw_wordmark.svg.js";
import SvgVwNytteSymbol from "./vwNytte_symbol.svg.js";
import SvgVwNytteWordmark from "./vwNytte_wordmark.svg.js";
const vw = {
  key: "vw",
  symbol: SvgVwSymbol,
  wordmark: SvgVwWordmark
};
const vwnytte = {
  key: "vwnytte",
  symbol: SvgVwNytteSymbol,
  wordmark: SvgVwNytteWordmark
};
export {
  vw,
  vwnytte
};
